<template>
  <div class="page page-refund">
    <navigation>申请退款</navigation>
    <div class="refund-main">
      <form ref="form">
        <div class="refund-section section-progress">
          <refund-progress :step="step"></refund-progress>
        </div>
        <div v-if="refundInfo.lastRejectReason" class="reject-reason">
          <van-icon class="reason-icon" name="warning-o" />
          退款拒绝原因：{{refundInfo.lastRejectReason}}
        </div>
        <div class="refund-section refund-info">
          <div class="info-title">{{refundInfo.goodsName}}</div>
          <div class="info-amount">
            ￥<span>{{refundInfo.refundAmount | currency}}</span>
          </div>
        </div>
        <template v-if="step === 1">
          <div v-if="needReason" class="refund-section refund-reason" @click="reasonVisible = true">
            <div class="reason-label">退款原因</div>
            <div class="reason-text">
              <span v-if="form.refundReasonDesc" class="has-value">{{form.refundReasonDesc}}</span>
              <span v-else>请选择</span>
              <i class="arrow-icon"></i>
            </div>
          </div>
          <div v-if="needBankInfo" class="refund-section refund-payee">
            <div class="payee-title">收款人信息</div>
            <div class="payee-content">
              <div class="payee-item">
                <div class="form-item">
                  <nd-input
                    name="accountName"
                    v-model="form.accountName"
                    maxLength="10"
                    label="收款名称"
                    inputStyle="width: 70%;margin-left: 30%"
                    placeholder="请输入收款人姓名"
                    text-align="right"
                  ></nd-input>
                </div>
              </div>
              <div class="payee-item">
                <div class="form-item">
                  <nd-input
                    name="bankCard"
                    v-model="form.bankCard"
                    maxLength="22"
                    label="银行账号"
                    placeholder="请输入银行账号"
                    text-align="right"
                  ></nd-input>
                </div>
              </div>
              <div class="payee-item">
                <div class="form-item">
                  <nd-input
                    name="openAccountAddress"
                    v-model="form.openAccountAddress"
                    maxLength="30"
                    label="开户银行"
                    inputStyle="width: 70%;margin-left: 30%"
                    placeholder="明细到支行"
                    text-align="right"
                  ></nd-input>
                </div>
              </div>
              <div class="payee-item">
                <div class="form-item">
                  <nd-address
                    name="bankAddress"
                    v-model="form.bankAddress"
                    :columns="2"
                    :mutilple="true"
                    inputStyle="width: 70%;margin-left: 30%"
                    label="开户地"
                  >
                  </nd-address>
                </div>
              </div>
            </div>
          </div>
          <div v-if="needEvidence" class="refund-section refund-voucher">
            <div class="voucher-title">
              上传凭证<span style="color: #409eff;font-weight: bold;font-size: 0.8em;margin-left: 1em;" @click="showSample">查看示例</span>
              <div class="voucher-sub">您的“{{evidenceTip}}“已使用，您可享“拒就赔特权”，请提供2家您在天美贷推荐的借款产品被拒的截图。</div>
            </div>
            <div class="voucher-content">
              <div class="form-item">
                <nd-upload
                  name="evidenceImageUrls"
                  :images.sync="form.evidenceImageUrls"
                  :limit="3"
                ></nd-upload>
              </div>
            </div>
          </div>
          <div class="refund-desc">
            <div class="desc-title">退款说明</div>
            <div class="desc-content">您的退款申请将于3个工作日内审核，审核通过后将会在7个工作日内退至您的银行卡。</div>
          </div>
        </template>
        <template v-if="step === 2">
          <div class="refund-section refund-message">
            <div class="message-title">退款信息</div>
            <div class="message-content">
              <div class="message-item">
                <div class="item-label">订单编号</div>
                <div class="item-content">{{refundInfo.refundRecordNo}}</div>
              </div>
              <div class="message-item">
                <div class="item-label">申请时间</div>
                <div class="item-content">{{refundInfo.refundApplyTime}}</div>
              </div>
            </div>
          </div>
          <div class="refund-desc">
            <div class="desc-title">温馨提醒</div>
            <div class="desc-content">退款申请将在10个工作日内处理，请耐心等待，如有任何疑问请联系客服</div>
          </div>
        </template>
      </form>
    </div>
    <div class="refund-bottom">
      <nd-button
        v-if="step === 1"
        :disabled="isDisabled || voicherDisabled || reasonDisabled"
        @click="handleApply"
      >提交</nd-button>
      <nd-button v-if="step === 2" @click="serviceVisible = true">联系客服</nd-button>
    </div>
    <!-- 联系客服弹窗框 -->
    <nd-dialog v-model="serviceVisible" @confirm="callService">
      <div class="service-dialog">
        <div class="title">联系客服</div>
        <div class="description">拨打客服电话进行咨询</div>
        <div class="description1">客服电话：{{customerServicePhone}}</div>
        <div class="telphone">服务时间：</div>
        <div class="telphone">周一到周五 上午9:00-12:00 下午13:30-18:00</div>
      </div>
    </nd-dialog>
    <refund-reason
      v-model="reasonVisible"
      :reasonList="refundReasonList"
      :reasonCode.sync="form.refundReasonCode"
      :reasonDesc.sync="form.refundReasonDesc"
    ></refund-reason>
  </div>
</template>

<script>
import RefundProgress from './components/refund-progress.vue'
import validate from '@/components/nd-validate/validateNew'
import { isEmojiCharacter, mockHrefJump } from '@/assets/utils'
import { mapActions } from 'vuex'
import RefundReason from './components/refund-reason.vue'
import { ImagePreview } from 'vant'

export default {
  components: {
    RefundProgress,
    RefundReason
  },
  mixins: [validate],
  data () {
    return {
      memberNo: this.$route.query.memberNo,
      customerServicePhone: '4000100008',
      serviceVisible: false,
      reasonVisible: false,
      step: 1,
      isDisabled: true,
      needBankInfo: false, // 是否需要收款人信息
      needEvidence: false, // 是否需要上传凭证
      needReason: false, // 是否需要退款原因
      refundInfo: {},
      refundReasonList: null,
      form: {
        refundReasonCode: '',
        refundReasonDesc: '',
        accountName: '',
        bankCard: '',
        openAccountAddress: '',
        bankAddress: null,
        evidenceImageUrls: []
      },
      rules: {
        accountName: [
          { require: true, message: '收款人姓名不能为空', trigger: 'blur' },
          {
            handler: input => /^[\u4e00-\u9fa5]{2,10}$/.test(input) && !isEmojiCharacter(input),
            message: '请输入正确的收款人姓名',
            trigger: 'blur'
          }
        ],
        bankCard: [
          { require: true, message: '银行账号不能为空', trigger: 'change' },
          {
            handler: input => /^\d{8,22}$/.test(input),
            message: '银行卡账号格式错误，请重新输入',
            trigger: 'blur'
          }
        ],
        openAccountAddress: [
          { require: true, message: '开户银行不能为空', trigger: 'change' },
          {
            handler: input => !isEmojiCharacter(input),
            message: '请输入正确的开户银行',
            trigger: 'blur'
          }
        ],
        bankAddress: [
          { require: true, message: '开户地不能为空', trigger: 'change' }
        ]
      }
    }
  },
  computed: {
    // 判断上传凭证是否可以提交
    voicherDisabled () {
      if (this.needEvidence) {
        if (this.form.evidenceImageUrls && this.form.evidenceImageUrls.length) {
          return false
        }
        return true
      }
      return false
    },
    // 判断退款原因是否可以提交
    reasonDisabled () {
      if (this.needReason) {
        if (this.form.refundReasonCode) {
          return false
        }
        return true
      }
      return false
    },
    // 上传凭证的提示，需要把卡 -> 特权
    evidenceTip () {
      if (this.refundInfo.goodsName) {
        return this.refundInfo.goodsName.replace('卡', '特权')
      }
      return ''
    }
  },
  created () {
    this.init()
  },
  mounted () {
    setTimeout(() => {
      // 如果内部的nd-input没有挂载完成，会导致validator方法报错，所以这里延迟执行
      if (this.step === 1 && this.needBankInfo) {
        this.validator(this.$refs['form'], this.rules)
      }
    }, 2000)
  },
  methods: {
    ...mapActions('refund', [
      'refundInitX',
      'refundApplyX'
    ]),
    callService () {
      mockHrefJump(`tel:${this.customerServicePhone}`)
    },
    // 初始化
    async init () {
      const { success, data } = await this.refundInitX({
        memberNo: this.memberNo,
        refundWay: 'APPLY'
      })
      if (success) {
        // 如果退款结束，直接返回到上一页
        if (data.refundMemberInfo.refundProcessEnd) {
          return this.$router.back()
        }
        this.refundInfo = data.refundMemberInfo
        this.needEvidence = data.needEvidence
        this.needBankInfo = data.needBankInfo
        this.needReason = data.needReason
        this.refundReasonList = data.refundReason
        // 如果不需要bankInfo，则直接将isDisabled设置为false
        if (!this.needBankInfo) {
          this.isDisabled = false
          this.rules = []
        }
        // 如果是退款中，则step设置为2
        if (this.refundInfo.refunding) {
          this.step = 2
        }
        return this.$bus.$emit('ready')
      }
      this.$bus.$emit('error')
    },
    // 提交退款申请
    async handleApply () {
      const bankInfo = {
        accountName: this.form.accountName,
        bankCard: this.form.bankCard,
        openAccountAddress: this.form.openAccountAddress
      }
      // 组装地址参数
      if (this.form.bankAddress) {
        const addressArr = this.form.bankAddress.split(' ')
        Object.assign(bankInfo, {
          openProvinceName: addressArr[0],
          openCityName: addressArr[1],
          openProvinceCode: addressArr[2],
          openCityCode: addressArr[3]
        })
      }
      const params = {
        memberNo: this.memberNo,
        evidenceImageUrls: this.form.evidenceImageUrls,
        bankInfo
      }
      // 组装退款原因参数
      if (this.needReason) {
        const { refundReasonCode, refundReasonDesc } = this.form
        Object.assign(params, {
          refundReasonCode,
          refundReasonDesc
        })
      }
      const { success } = await this.refundApplyX(params)
      if (success) {
        window.location.reload()
      }
    },
    // 查看示例图片
    showSample () {
      const sample1Image = require('./images/sample1.jpg')
      const sample2Image = require('./images/sample2.jpg')
      ImagePreview({
        images: [sample1Image, sample2Image],
        closeable: true
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/less/mixin.less";

.page-refund{
  background-color: #F7F7F7;
  padding-bottom: 270px;
  .refund-main{
    padding: 40px 30px 0;
    .refund-section{
      background-color: #fff;
      border-radius: 20px;
      &.section-progress{
        padding: 70px 60px 37px;
      }
      &.refund-info{
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #333333;
        padding: 57px 0 66px;
        .info-title{
          font-size: 24px;
        }
        .info-amount{
          font-family: DIN-Medium, DIN;
          font-size: 48px;
          font-weight: 500;
          margin-top: 7px;
          span{
            font-size: 72px;
          }
        }
      }
      &.refund-reason{
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 30px 50px 30px 30px;
        position: relative;
        font-size: 30px;
        .reason-label{
          color: #333333;
          font-weight: 400;
          font-family: 'PingFangSC-Regular';
          flex: 0 0 auto;
          margin-right: 20px;
        }
        .reason-text{
          color: #AAAAAA;
          .has-value{
            color: #333333;
          }
          .arrow-icon{
            display: block;
            position: absolute;
            top: 50%;
            right: 30px;
            height: 20px;
            margin-top: -10px;
            width: 11px;
            background: url(../../components/nd-cell/images/arrow.png) no-repeat;
            background-size: 100%;
          }
        }
      }
      &.refund-payee{
        margin-top: 30px;
        .payee-title{
          padding-left: 90px;
          height: 100px;
          display: flex;
          align-items: center;
          background: url(./images/icon_user@2x.png) 30px center no-repeat;
          background-size: 44px;
          font-size: 30px;
          font-weight: 500;
          color: #333333;
          border-bottom: 1PX solid #EEEEEE;
        }
        .payee-content{
          padding-left: 90px;
          padding-right: 20px;
          .payee-item{
            height: 110px;
            line-height: 110px;
            /deep/.nd-select-text{
              font-size: 30px;
            }
            & + .payee-item{
              border-top: 1PX solid #EEEEEE;
            }
          }
        }
      }
      &.refund-voucher{
        margin-top: 30px;
        .voucher-title{
          align-items: center;
          background: url(./images/icon_card@2x.png) 30px 27px no-repeat;
          background-size: 44px;
          font-size: 30px;
          font-weight: 500;
          color: #333333;
          border-bottom: 1PX solid #EEEEEE;
          padding: 28px 0 26px 90px;
          .voucher-sub{
            font-size: 24px;
            color: #999999;
            margin-top: 8px;
            padding-left: 30px;
          }
        }
        .voucher-content{
          padding: 30px 0 50px 87px;
        }
      }
      &.refund-message{
        margin-top: 30px;
        .message-title{
          padding-left: 90px;
          height: 100px;
          display: flex;
          align-items: center;
          background: url(./images/icon_info@2x.png) 30px center no-repeat;
          background-size: 44px;
          font-size: 30px;
          font-weight: 500;
          color: #333333;
          border-bottom: 1PX solid #EEEEEE;
        }
        .message-content{
          padding-left: 90px;
          .message-item{
            height: 110px;
            line-height: 110px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding-right: 50px;
            & + .message-item{
              border-top: 1PX solid #EEEEEE;
            }
            .item-label{
              flex: 0 0 auto;
              font-size: 30px;
              color: #333333;
            }
            .item-content{
              word-break: break-all;
              line-height: 1.5;
              margin-left: 30px;
            }
          }
        }
      }
    }
    .reject-reason{
      background-color: #FFF7E5;
      line-height: 30px;
      font-size: 22px;
      color: #763E12;
      padding: 15px 30px;
      border-radius: 10px;
      margin-top: 30px;
      .reason-icon{
        font-size: 30px;
        margin-right: 12px;
        vertical-align: bottom;
      }
    }
    .refund-desc{
      margin-top: 30px;
      .desc-title{
        font-size: 30px;
        color: #333333;
        font-weight: bold;
      }
      .desc-content{
        font-size: 24px;
        color: #999999;
        margin-top: 8px;
        line-height: 33px;
      }
    }
  }
  .refund-bottom{
    background-color: #fff;
    position: fixed;
    bottom: 0;
    width: 750px;
    left: auto;
    right: auto;
    padding: 28px 50px 58px;
    .bottom-btn{
      width: 100%;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      line-height: 94px;
      text-align: center;
      border-radius: 47px;
      color: #fff;
      font-size: 32px;
    }
  }
}
.service-dialog {
  padding-top: 10px;
  padding: 0 48px;
  padding-bottom: 80px;
  font-family: PingFangSC-Regular,PingFang SC;
  .title {
    font-size: 42px;
    height: 72px;
    line-height: 72px;
    font-family: PingFangSC-Semibold,PingFang SC;
    font-weight: 600;
  }
  .description {
    font-size: 30px;
    height: 32px;
    line-height: 32px;
    margin-top: 22px;
    font-weight: 400;
  }
  .description1{
    font-size: 30px;
    height: 32px;
    line-height: 32px;
    margin: 12px auto 12px;
    font-weight: 400;
  }
  .telphone {
    font-size: 24px;
    height: 40px;
    line-height: 40px;
    margin-top: 2px;
    font-weight: 400;
    color: @fc3;
  }
}
</style>